import { render, staticRenderFns } from "./keyboard.vue?vue&type=template&id=946c8736&scoped=true&"
import script from "./keyboard.vue?vue&type=script&lang=js&"
export * from "./keyboard.vue?vue&type=script&lang=js&"
import style0 from "./keyboard.vue?vue&type=style&index=0&id=946c8736&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "946c8736",
  null
  
)

export default component.exports